// date range directive
//
//   <date-range start="vm.startDate" end="vm.endDate" />

let module = angular.module('app.directives');

module.directive('dateRange', () => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { start: '=', end: '=', unstyled: '=' },
    template: `
      <span ng-class="{'date-range': !unstyled}">{{start | date:'MMM d, y h:mm a'}}</span>
      <span ng-if="end && !end.startsWith('9999-12-31')">
        - <span ng-class="{'date-range': !unstyled}">{{endDateDisplay}}{{end | date:'shortTime'}}</span>
      </span>
    `,
    link: (scope, element) => {
      scope.endDateDisplay = '';
      scope.$watchCollection(
        () => [scope.start, scope.end],
        () => {
          let startDay = moment(scope.start).format('MMM D'); // XXX: moment date format uses D while angular uses d
          let endDay = moment(scope.end).format('MMM D');
          if (startDay != endDay) {
            scope.endDateDisplay = endDay + ' ';
          } else {
            scope.endDateDisplay = '';
          }
        }
      );
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/date-range.js